// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "32c850ea0c6a0e68fa34f36bd9c5d775b0b54d30/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};